import { render, staticRenderFns } from "./courseDiscount.vue?vue&type=template&id=3e38ec52&scoped=true&"
import script from "./courseDiscount.vue?vue&type=script&lang=js&"
export * from "./courseDiscount.vue?vue&type=script&lang=js&"
import style0 from "./courseDiscount.vue?vue&type=style&index=0&id=3e38ec52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e38ec52",
  null
  
)

export default component.exports